<mat-card>
  <mat-card-header>
    <mat-card-title>Búsqueda de Materiales de Pedido</mat-card-title>
  </mat-card-header>

  <mat-card-content>

    <div fxLayout="row stretch" fxLayout.xs="column" style="margin: 10px 0px;">
      <mat-label *ngIf="isValidating"><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
    </div>

    <ng-container *ngIf="canView">

      <mat-expansion-panel *ngIf="!isValidating">

        <mat-expansion-panel-header>
          <mat-panel-title>
            <mat-icon style="margin-top: -3px;">search</mat-icon> Filtros de Búsqueda
          </mat-panel-title>
          <mat-panel-description>
          </mat-panel-description>
        </mat-expansion-panel-header>

        <form [formGroup]="searchForm">

          <div fxLayout="row stretch" fxLayout.xs="column">

            <div fxFlex=33 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>Número</mat-label>
                <input matInput type="number" formControlName="PedidoId" placeholder="Número"
                  aria-label="Número" (keyup.enter)="onSearch()">
              </mat-form-field>
            </div>
            <div fxFlex=33 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>Comunidad Origen</mat-label>
                <input type="text" matInput [matAutocomplete]="obras"
                  formControlName="ComunidadOrigen" (keyup.enter)="onSearch()">
                <i [ngStyle]="{'display': isComunidadSearching ? 'inline-block' : 'none'}" class="fa fa-spinner fa-spin"
                  style="position: absolute; right: 0"></i>
              </mat-form-field>
              <mat-autocomplete #obras="matAutocomplete" [displayWith]="displayComunidad">
                <mat-option *ngFor="let s of filteredComunidadesList" [value]="s">
                  {{ sharedFunctions.formatComunidadName(s) }}
                </mat-option>
              </mat-autocomplete>
            </div>
            <div fxFlex=34 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>Comunidad Destino</mat-label>
                <input type="text" matInput
                  [matAutocomplete]="obras" formControlName="ComunidadDestino" (keyup.enter)="onSearch()">
                <i [ngStyle]="{'display': isComunidadSearching ? 'inline-block' : 'none'}" class="fa fa-spinner fa-spin"
                  style="position: absolute; right: 0"></i>
              </mat-form-field>
              <mat-autocomplete #obras="matAutocomplete" [displayWith]="displayComunidad">
                <mat-option *ngFor="let s of filteredComunidadesList" [value]="s">
                  {{ sharedFunctions.formatComunidadName(s) }}
                </mat-option>
              </mat-autocomplete>
            </div>

            <!--Material-->
            <div fxFlex=33 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>Material</mat-label>
                <input type="text" matInput [matAutocomplete]="materiales"
                  formControlName="MaterialNombre" (keyup.enter)="onSearch()">
                <!-- <i [ngStyle]="{'display': isComunidadSearching ? 'inline-block' : 'none'}" class="fa fa-spinner fa-spin"
                  style="position: absolute; right: 0"></i> -->
              </mat-form-field>
              <mat-autocomplete #materiales="matAutocomplete" [displayWith]="displayMaterial">
                <mat-option *ngFor="let material of filteredMaterialList" [value]="material">
                  {{ sharedFunctions.formatComunidadName(material) }}
                </mat-option>
              </mat-autocomplete>
            </div>
<!--Material--> 

            <div fxFlex=33 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label *ngIf="!isEstadoSearching">Estados</mat-label>
                <mat-label *ngIf="isEstadoSearching">Cargando...</mat-label>
                <mat-select formControlName="Estados" multiple>
                  <mat-option *ngFor="let s of estadoList" [value]="s.Id">{{s.Nombre}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div fxFlex=33 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label *ngIf="!isTipoMaterialSearching">{{'TipoMaterial'}}</mat-label>
                <mat-label *ngIf="isTipoMaterialSearching">Cargando...</mat-label>
                <mat-select formControlName="TipoMaterialId" (selectionChange)="onSearch()">
                  <mat-option [value]="0">Todos</mat-option>
                  <mat-option *ngFor="let s of tipoMaterialList" [value]="s.Id">{{s.Nombre}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div fxFlex=33.33 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%" *ngIf="!verSoloMisPendientesAprobacion">
                <mat-label *ngIf="!isRolSearching">Rol de Aprobador</mat-label>
                <mat-label *ngIf="isRolSearching">Cargando...</mat-label>
                <mat-select formControlName="RolId">
                  <mat-option>Todos</mat-option>
                  <mat-option *ngFor="let s of rolList" [value]="s.Id">{{s.Nombre}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div fxFlex=33.33 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label *ngIf="!isRubroContableSearching">{{'Rubro Contable'}}</mat-label>
                <mat-label *ngIf="isRubroContableSearching">Cargando...</mat-label>
                <mat-select formControlName="RubroContableId">
                  <mat-option [value]="0">Todos</mat-option>
                  <mat-option autocomplete="off" *ngFor="let s of rubroContableList" [value]="s.Id">{{s.Codigo + '. '+ s.Nombre}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>      
            
    
          
        
            <div fxFlex=100 fxFlex.xs=100 class="flex-item">
              <mat-checkbox formControlName="VerSoloMisPendientesAprobacion" (keyup.enter)="onSearch()" color="primary">Ver Solo Mis Pendientes de Aprobación</mat-checkbox>
            </div>

          </div>

        </form>

      </mat-expansion-panel>

      <div fxLayout="row stretch" fxLayout.xs="column" style="margin: 10px 0px">
        <button mat-raised-button (click)="onSearch()" [disabled]="isSearching" color="primary"
          class="zb-button">{{isSearching ? 'Buscando...' : 'Buscar'}}</button>
        <button mat-raised-button (click)="onExportItem()" [disabled]="isExporting" color="warn"
          class="zb-button">{{isExporting ? 'Exportando...' : 'Exportar'}}</button>
      </div>

      <div fxLayout="row stretch" fxLayout.xs="column" style="margin: 10px 0px;">
        <mat-label *ngIf="isSearching"><i class="fa fa-spinner fa-spin"></i> Buscando...</mat-label>
      </div>

      <div fxLayout="row stretch" fxLayout.xs="column" *ngIf="!isSearching">
        <ejs-grid #grid [dataSource]='data' [query]='query' [allowPaging]="true" [allowSorting]="true"
          [toolbar]='toolbarOptions' [selectionSettings]='selectionOptions' [pageSettings]='pageSettings'
          [allowResizing]='true' (actionFailure)="onGridActionFailure($event)" (actionBegin)="onActionBegin($event)">
          <e-columns>
            <e-column field='PedidoId' headerText='#' textAlign="center" width=50></e-column>
            <e-column field='ComunidadOrigenNombre' headerText='Origen' width=90></e-column>
            <e-column field='ComunidadDestinoNombre' headerText='Destino' width=90></e-column>
            <e-column field='EstadoNombre' headerText='Estado' width=90></e-column>
            <e-column field='MaterialNombre' headerText='Material' width=90></e-column>
            <e-column field='Cantidad' headerText='Cantidad' width=90></e-column>
            <e-column field='RubroContableNombre' headerText='Rubro Contable' width=90></e-column>
            <e-column field='ProveedorNombre' headerText='Proveedor' width=90></e-column>
            <e-column field='FechaNecesidad' format="dd/MM/yyyy" headerText='Fecha Necesidad' width=90></e-column>
            <e-column field='FechaEntregaPlanificada' format="dd/MM/yyyy" headerText='Entrega Planif.' width=90></e-column>
            <e-column field='Observacion' headerText='Observación' width=90></e-column>
            <e-column field='PedidoComunidadRol' headerText='Aprobador' width=90></e-column>
            <e-column headerText='Acciones' textAlign="center" width=90>
              <ng-template #template let-data>
                <a style="cursor: pointer; margin-right: 5px" (click)="view(data)"><i class="fa fa-eye fa-1x"></i></a>
              </ng-template>
            </e-column>
          </e-columns>
        </ejs-grid>
      </div>

    </ng-container>

  </mat-card-content>

</mat-card>